module.exports = __webpack_public_path__ + "media/language-picker/globe-4bb65d40.png";